// Amount in words, Nepali/Indian style (lakh, crore), with paisa when present (Stage 2E-2, owner decision D6):
//   125000.5 → "One Lakh Twenty-Five Thousand Rupees and Fifty Paisa Only". Pure; no rounding of its own —
//   the value comes from the database (two decimals) and is read as text so no floating-point error can creep in.
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen",
    "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const two = (n) => (n < 20 ? ONES[n] : TENS[Math.floor(n / 10)] + (n % 10 ? "-" + ONES[n % 10] : ""));
const three = (n) => [n >= 100 ? `${ONES[Math.floor(n / 100)]} Hundred` : "", n % 100 ? two(n % 100) : ""].filter(Boolean).join(" ");

// Whole number → words in the lakh/crore system ("Zero" for 0). Above 99 crore the crore part is itself spelled out.
export function inWords(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("inWords: a whole number ≥ 0 is required");
    if (n === 0) return "Zero";
    const crore = Math.floor(n / 1e7), rest = n % 1e7;
    return [
        crore ? `${inWords(crore)} Crore` : "",
        Math.floor(rest / 1e5) ? `${two(Math.floor(rest / 1e5))} Lakh` : "",
        Math.floor((rest % 1e5) / 1000) ? `${two(Math.floor((rest % 1e5) / 1000))} Thousand` : "",
        rest % 1000 ? three(rest % 1000) : "",
    ].filter(Boolean).join(" ");
}

// Split a money value ("68400.00", 68400, "0.5") into whole rupees and paisa without floating-point arithmetic.
export function splitMoney(value) {
    const s = typeof value === "number" ? value.toFixed(2) : String(value ?? "").trim();
    const m = /^(\d+)(?:\.(\d{1,2}))?$/.exec(s);
    if (!m) throw new Error(`amountInWords: not a non-negative amount with at most 2 decimals: ${s}`);
    return { rupees: Number(m[1]), paisa: Number((m[2] || "0").padEnd(2, "0")) };
}

export function amountInWords(value) {
    const { rupees, paisa } = splitMoney(value);
    if (!rupees && !paisa) return "Zero Rupees Only";
    const r = rupees ? `${inWords(rupees)} ${rupees === 1 ? "Rupee" : "Rupees"}` : "";
    const p = paisa ? `${two(paisa)} Paisa` : "";
    return `${[r, p].filter(Boolean).join(" and ")} Only`;
}
